import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "app/store";
import { BulkEditLotOffersInterface, fetchBulkEditLotOffers } from "./fetchBulkEdit";

export const bulkEdit = createAsyncThunk("lotList/fetchBulkEdit", async (args: BulkEditLotOffersInterface, { getState }) => {
    const { user } = getState() as RootState;
    const response = await fetchBulkEditLotOffers({ ...args, endpoint: user.role });
    return { headers: response.headers, data: response.data, status: response.status };
});

